import { APP_MODULE_NAME } from '../utils/ModuleMap';
const EMPTY_LINKS = Object.freeze({});
export const getEmail = state => state.getIn(['modules', APP_MODULE_NAME, 'privacy', 'email'], '');
export const getIsLoading = state => state.getIn(['modules', APP_MODULE_NAME, 'privacy', 'isLoading'], false);
export const getIntlLinks = (state, activeLocale) => state.getIn(['intl', 'languagePacks', activeLocale, APP_MODULE_NAME, 'data', 'links'], EMPTY_LINKS);
export const getPreferenceStatus = state => state.getIn(['modules', APP_MODULE_NAME, 'privacy', 'preferenceStatus'], null);
export const getOriginalPreferenceStatus = state => state.getIn(['modules', APP_MODULE_NAME, 'privacy', 'originalPreferenceStatus'], null);
export const getApplicationToken = state => state.getIn(['modules', APP_MODULE_NAME, 'privacy', 'applicationToken'], null);
export const getCardToken = state => state.getIn(['modules', APP_MODULE_NAME, 'privacy', 'cardToken'], null);
export const getEnv = state => state.getIn(['config', 'ENV'], 'e0');

// export const getPreferenceChecked = (state) => state.getIn(
//   ['modules', APP_MODULE_NAME, 'privacy', 'preferenceChecked'],
//   false
// );

// export const getIdaasToken = (state) => state.getIn(
//   ['modules', APP_MODULE_NAME, 'privacy', 'idaasToken'],
//   null
// );

// export const getApplicationTokenMeta = (state) => ({
//   expiresIn:
// state.getIn(['modules', APP_MODULE_NAME, 'privacy', 'applicationTokenExpiresIn'], null),
//   fetchedAt:
// state.getIn(['modules', APP_MODULE_NAME, 'privacy', 'applicationTokenFetchedAt'], null),
// });

// export const getNavBaseUrl = (state) => state.getIn(['config', 'navBaseUrl'], null);

export const encryptionKey = state => state.getIn(['config', 'ENCRYPTION_KEY'], null);
// export const aesIv = (state) => state.getIn(['config', 'ENCRYPTION_AES_IV'], null)
export const desIv = state => state.getIn(['config', 'ENCRYPTION_DES_IV'], null);
export const getVaultConfig = state => ({
  encryptionKey: encryptionKey(state),
  // aesIv: aesIv(state),
  desIv: desIv(state)
});

// export const getEpccConfig = (state) => ({
//   tokenUrl: state.getIn(['config', 'EPCC_TOKEN_URL']),
//   searchUrl: state.getIn(['config', 'EPCC_search_URL']),
//   updateUrl: state.getIn(['config', 'EPCC_UPDATE_URL']),
// });